// Import and register all your controllers manually
import { application } from "./application"

// Import individual controllers
import ReviewFormController from "./review_form_controller"
import SampleController from "./sample_controller"

application.register("review-form", ReviewFormController)
application.register("sample", SampleController)
